"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _react = require("@emotion/react");

var _util = require("../../../util");

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var buttonWithBackground = process.env.NODE_ENV === "production" ? {
  name: "ik99b7",
  styles: "transform:scale(1);opacity:1"
} : {
  name: "1bmp3fv-buttonWithBackground",
  styles: "transform:scale(1);opacity:1;label:buttonWithBackground;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

var base = function base(_ref) {
  var theme = _ref.theme,
      noticeCount = _ref.noticeCount,
      alert = _ref.alert,
      isLeftSidebarCollapsed = _ref.isLeftSidebarCollapsed;
  return /*#__PURE__*/(0, _react.css)("line-height:0;position:relative;&&.active:not(.basic){background-color:", theme.color.globalNav.iconActiveBackground, ";}&&.active:not(.basic)::before{content:'';position:absolute;background-color:transparent;top:-48px;right:0px;height:48px;width:6px;border-bottom-right-radius:6px;box-shadow:0 6px 0 0 ", theme.color.globalNav.iconActiveBackground, ";z-index:1;}&&.active:not(.basic)::after{content:'';position:absolute;background-color:transparent;right:0;bottom:-48px;height:48px;width:6px;border-top-right-radius:6px;box-shadow:0 -6px 0 0 ", theme.color.globalNav.iconActiveBackground, ";z-index:1;}&&.active:not(.basic)>div:first-of-type:before{border:solid 2px ", theme.color.globalNav.iconActiveBackground, ";}&&.active a,&&.active button{color:", isLeftSidebarCollapsed ? theme.color.globalNav.iconActiveBasic : theme.color.globalNav.iconActive, ";&::before{", isLeftSidebarCollapsed && buttonWithBackground, ";}}>div:first-of-type>*{white-space:nowrap;}>div:first-of-type:before{display:", noticeCount || alert ? 'block' : 'none', ";content:'", noticeCount || '', "';position:absolute;top:6px;right:4px;background:", theme.color.globalNav.noticeCountBackground, ";border:solid 2px ", theme.color.globalNav.noticeCountColor, ";border-radius:10px;height:auto;font-size:", theme.fontSize.xtiny, ";font-weight:", theme.fontWeight.medium, ";color:", theme.color.globalNav.noticeCountColor, ";line-height:1;text-align:center;padding:2px;min-width:16px;min-height:16px;z-index:3;}" + (process.env.NODE_ENV === "production" ? "" : ";label:base;"));
};

var iconButton = function iconButton(theme) {
  return /*#__PURE__*/(0, _react.css)("width:", (0, _util.rem)(48), ";height:", (0, _util.rem)(48), ";border-radius:0;&&::before{bottom:", theme.spacing[3], ";left:", theme.spacing[3], ";right:", theme.spacing[3], ";top:", theme.spacing[3], ";border-radius:", theme.spacing[3], ";}&:hover{color:", theme.color.globalNav.iconActiveBasic, ";}svg{width:", theme.spacing[10], ";height:", theme.spacing[10], ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:iconButton;"));
};

var styles = {
  base: base,
  iconButton: iconButton
};
exports.styles = styles;
//# sourceMappingURL=GlobalNavItem.styles.js.map